module.exports = __webpack_public_path__ + "static/img/banner.3d674de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/banner.png
// module id = iYSC
// module chunks = 1